<template>
  <div class="table-container">
    <table class="table">
      <thead>
        <tr>
          <th v-for="(value, key) in filteredData[0]" :key="key">
            {{ formatKey(key) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in filteredData" :key="index">
          <td v-for="(value, key) in row" :key="key">{{ value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sss: null,
    };
  },
  props: {
    queueItems: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  watch: {
    queueItems() {
      console.log(this.queueItems);
    },
  },
  computed: {
    filteredData() {
      const excludeKeys = [
        '_id',
        'user_id',
        'device_id',
        'client_id',
        'secret',
        '__v',
        'integration',
        'message_status',
        'message_counter',
        'cliente',
      ];

      return this.queueItems.map(item => {
        const filteredItem = Object.keys(item)
          .filter(
            key =>
              !excludeKeys.includes(key) &&
              item[key] !== '' &&
              item[key] !== null &&
              item[key] !== undefined
          )
          .reduce((obj, key) => {
            if (key === 'created_at' && item[key]) {
              const date = new Date(item[key]);
              obj[key] = date.toLocaleDateString('pt-BR');
            } else {
              obj[key] = item[key];
            }
            return obj;
          }, {});

        return filteredItem;
      });
    },
  },
  methods: {
    formatKey(key) {
      return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },
  },
};
</script>
<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-family: sans-serif;
  font-size: 0.95rem;
  background-color: #fff;
  border-radius: 8px;
}

.table thead {
  background-color: #f5f5f5;
  text-align: left;
}

.table th,
.table td {
  padding: 0.75em 1em;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
}

.table tbody tr:hover {
  background-color: #f9f9f9;
}
</style>
